/* --- (Final v7) Gallery Logic with Correctly Scaled Background Video --- */
(function($) {
  if (typeof $ === 'undefined') {
    document.addEventListener('DOMContentLoaded', function() { initGalleryLogic(window.jQuery); });
  } else {
    $(document).ready(function() { initGalleryLogic($); });
  }

  // Функція для завантаження YouTube API
  function loadYouTubeAPI() {
    if (window.YT && window.YT.Player) {
      if (typeof window.onYouTubeIframeAPIReady === 'function') {
        window.onYouTubeIframeAPIReady();
      }
      return;
    }
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // Функція для зміни розміру плеєра, щоб він покривав контейнер
  function resizePlayer(playerElement) {
    var $container = $(playerElement).closest('.video-background-wrapper');
    if (!$container.length) return;

    var containerWidth = $container.width();
    var containerHeight = $container.height();
    var videoAspectRatio = 16 / 9; // Стандартне співвідношення для YouTube

    var newWidth, newHeight;

    if (containerWidth / containerHeight > videoAspectRatio) {
      // Контейнер ширший за відео
      newWidth = containerWidth;
      newHeight = containerWidth / videoAspectRatio;
    } else {
      // Контейнер вищий за відео
      newHeight = containerHeight;
      newWidth = containerHeight * videoAspectRatio;
    }

    $(playerElement).width(newWidth).height(newHeight);
  }


  function initGalleryLogic($) {
    var desktopBreakpoint = 768;
    
    // Глобальна функція, яка викликається YouTube API
    window.onYouTubeIframeAPIReady = function() {
      $('.youtube-player').each(function() {
        var playerElement = this;
        var playerId = $(playerElement).attr('id');
        var videoId = $(playerElement).data('video-id');
        
        if (videoId) {
          new YT.Player(playerId, {
            videoId: videoId,
            playerVars: {
              'autoplay': 1, 'controls': 0, 'mute': 1, 'loop': 1,
              'playlist': videoId, 'showinfo': 0, 'modestbranding': 1,
              'autohide': 1, 'rel': 0, 'playsinline': 1
            },
            events: {
              'onReady': function(event) {
                event.target.playVideo();
                // Встановлюємо правильний розмір одразу
                resizePlayer(event.target.getIframe());
              },
              'onError': function(event) {
                $(event.target.getIframe()).closest('.gallery-item--video-background').addClass('video-loaded');
              }
            }
          });
        }
      });
    };

    // Запускаємо завантаження API
    loadYouTubeAPI();

    var resizeTimer;
    $(window).on('resize.galleryReload', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Логіка перезавантаження сторінки
        var wasMobile = $(this).data('wasMobile');
        if (typeof wasMobile === 'undefined') {
            wasMobile = $(window).width() < desktopBreakpoint;
            $(this).data('wasMobile', wasMobile);
        }
        var isMobile = $(window).width() < desktopBreakpoint;
        if (isMobile !== wasMobile) {
          location.reload();
        }

        // Змінюємо розмір всіх плеєрів
        $('.youtube-player').each(function() {
          resizePlayer(this);
        });

      }, 250);
    });
  }
})();